import { ORDER_METHODS } from '../../../../../services/exports/Constants';
import { ValidationErrors } from '../../../../../modals/order-method/types';

export default {
  title: 'Selecionar localização',
  order_methods: {
    [ORDER_METHODS.ON_SITE]: 'Pedido à mesa',
    [ORDER_METHODS.PICKUP]: 'Levantamento',
    [ORDER_METHODS.DELIVERY]: 'Entrega',
  },
  text_inputs: {
    address: {
      placeholder: 'Pesquisar morada',
    },
    street_name: {
      placeholder: 'Rua',
    },
    street_number: {
      placeholder: 'Número',
    },
    city: {
      placeholder: 'Cidade',
    },
    zip: {
      placeholder: 'Código postal',
    },
  },
  time_options: {
    asap: {
      title: 'Normal',
      description: 'Pronto em {{time}} min',
    },
    scheduled: {
      title: 'Agendar para mais tarde',
    },
  },
  time_drop_down: {
    today: 'Hoje',
  },

  pickup: {
    address: 'Morada de levantamento',
    when: 'Quando?',
  },

  delivery: {
    where: 'Para onde?',
    when: 'Quando?',
    address: 'A sua morada',
    delivery_area: 'A nossa área de entrega',
  },

  buttons: {
    view_menu: 'Ver menu',
    see_hours: 'Ver horários',
    next: 'Seguinte',
    change: 'Alterar',
    save: 'Guardar',
  },

  labels: {
    when: 'Quando?',
    pickup: 'Levantamento online',
    delivery: 'Entrega',
    pickup_time: 'hora de levantamento',
    delivery_time: 'hora de entrega',
    discount: 'Só aqui {{value}} de desconto online',
    pre_orders_enabled: 'Por agora, pode fazer uma encomenda agendada para mais tarde',
    change_location: '← Voltar ao menu se preferir uma localização diferente',
    return: 'Voltar',
  },

  items_dropped: {
    count_one: '{{count}} artigo removido',
    count_other: '{{count}} artigos removidos',
    pickup_reason: '— não disponível para levantamento.',
    delivery_reason: '— não disponível para entrega.',
  },

  error_messages: {
    [ValidationErrors.address_not_found]:
      'Desculpe, não encontrámos esse endereço. Tente novamente inserindo primeiro a rua no campo de pesquisa de endereço.',
    [ValidationErrors.address_not_serviceable]:
      'O seu endereço está fora da nossa zona de entrega. Pretende alterar o endereço ou mudar para recolha? 😊',
    [ValidationErrors.no_drivers_available]:
      'Desculpe, não conseguimos entregar neste momento. Quer encomendar para recolha? 😊',
    pickup_unavailable: 'Lamentamos, mas de momento não oferecemos recolha.',
    delivery_unavailable: 'Lamentamos, mas de momento não oferecemos entrega.',
    delivery_paused: 'Lamentamos, mas de momento não oferecemos entrega.',
    outside_pickup_times: 'Não oferecemos recolha neste momento. Os nossos horários de recolha:',
    outside_delivery_times: 'Não oferecemos entrega neste momento. Os nossos horários de entrega:',
    orders_paused_inactivity:
      'Devido à elevada procura, não conseguimos aceitar mais encomendas online agora. Por favor, encomende na loja ou tente novamente em 30 minutos.',
    orders_paused_manual_end_of_day: 'Desculpe, estamos encerrados pelo resto do dia.',
    orders_paused_manual_until_time:
      'Devido à elevada procura, não conseguimos aceitar mais encomendas online agora. Por favor, encomende na loja ou tente novamente a partir de {{pausedUntil}}',
    company_closed: 'Infelizmente, não estamos abertos neste momento.',
    pickup_closed:
      'Aceitamos encomendas de recolha até às {{time}} porque o nosso tempo de preparação é de {{preparationTime}} minutos.',
    delivery_closed:
      'Aceitamos encomendas de entrega até às {{time}} porque o nosso tempo de entrega é de {{preparationTime}} minutos.',
    live_orders_off:
      'Lamentamos, de momento não conseguimos aceitar mais encomendas online. Obrigado pela sua compreensão.',
    orders_unavailable:
      '{{type}} não está disponível neste momento. O próximo {{typeTime}} possível é {{day}} {{time}}.',
  },

  no_couriers: {
    with_code:
      'Lamentamos, não temos estafetas disponíveis agora. Tente mais tarde ou encomende para recolha e use o código promocional <PromoCode>{{code}}</PromoCode> no checkout.',
    without_code: 'Lamentamos, não temos estafetas disponíveis agora. Tente mais tarde ou encomende para recolha.',
    copied: 'Código promocional copiado',
  },
};
